import { render, staticRenderFns } from "./BaseFormField.vue?vue&type=template&id=591d3b8a&scoped=true&"
import script from "./BaseFormField.vue?vue&type=script&lang=js&"
export * from "./BaseFormField.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormField.vue?vue&type=style&index=0&id=591d3b8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d3b8a",
  null
  
)

export default component.exports